import * as React from "react";
import { forwardRef } from "react";
const SvgVerticalDivider = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 214, viewBox: "0 0 21 214", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 13, height: 209, transform: "translate(3.96875 2.48486)", fill: "#1F2B3D" }), /* @__PURE__ */ React.createElement("path", { d: "M3.96875 0.484863L16.9688 106.985L3.96875 213.485", stroke: "#182231", strokeWidth: 8 }));
const ForwardRef = forwardRef(SvgVerticalDivider);
export { ForwardRef as ReactComponent };
